import React from 'react';

import type { FlagProps } from '../src/types';

const FlagIr = ({ className, testID }: FlagProps) => (
  <svg
    width={20}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testID}
    className={className}
    aria-hidden="true"
  >
    <mask
      id="prefix__a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={15}
    >
      <path fill="#fff" d="M0 0h20v15H0z" />
    </mask>
    <g mask="url(#prefix__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0v15h20V0H0z"
        fill="#F7FCFF"
      />
      <mask
        id="prefix__b"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={15}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#prefix__b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0v5h20V0H0z"
          fill="#5EAA22"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10v5h20v-5H0z"
          fill="#E31D1C"
        />
        <path
          d="M.233 10.854h-1.421m-.015.563v-.326h.463v.315h.467v-.315h-.242m.726.313h-.235v-.306h.496v-.251.557h.224v-.557m.253.033v.526H.716m1.956-.552H1.25m-.014.563v-.326h.463v.315h.467v-.315h-.242m.77.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.552h-1.42m-.015.563v-.326h.462v.315h.468v-.315h-.243m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.957-.552H6.172m-.014.563v-.326h.462v.315h.468v-.315h-.243m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.253.033v.526h-.234m1.957-.552H8.61m-.013.563v-.326h.462v.315h.468v-.315h-.243m.771.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.552h-1.421m-.014.563v-.326h.462v.315h.467v-.315h-.242m.77.313h-.235v-.306h.496v-.251.557h.224v-.557m.253.033v.526h-.233m1.956-.552h-1.422m-.014.563v-.326h.462v.315h.468v-.315h-.243m.771.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.552h-1.42m-.016.563v-.326h.463v.315h.467v-.315h-.242m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.957-.552h-1.422m-.015.563v-.326h.463v.315h.468v-.315h-.243m.858.313h-.236v-.306h.496v-.251.557h.224v-.557M.233 3.23h-1.421m-.015.562v-.326h.463v.315h.467v-.315h-.242m.726.313h-.235v-.306h.496v-.251.557h.224v-.557m.253.033v.526H.716m1.956-.551H1.25m-.014.562v-.326h.463v.315h.467v-.315h-.242m.77.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.551h-1.42m-.015.562v-.326h.462v.315h.468v-.315h-.243m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.957-.551H6.172m-.014.562v-.326h.462v.315h.468v-.315h-.243m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.253.033v.526h-.234m1.957-.551H8.61m-.013.562v-.326h.462v.315h.468v-.315h-.243m.771.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.551h-1.421m-.014.562v-.326h.462v.315h.467v-.315h-.242m.77.313h-.235v-.306h.496v-.251.557h.224v-.557m.253.033v.526h-.233m1.956-.551h-1.422m-.014.562v-.326h.462v.315h.468v-.315h-.243m.771.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.551h-1.42m-.016.562v-.326h.463v.315h.467v-.315h-.242m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.957-.551h-1.422m-.015.562v-.326h.463v.315h.468v-.315h-.243m.858.313h-.236v-.306h.496v-.251.557h.224v-.557"
          stroke="#F7FCFF"
          strokeWidth={0.625}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.129 5.156s.267.14.54.14c.274 0 .549-.14.549-.14v.188s-.3.14-.566.14c-.266 0-.523-.14-.523-.14v-.188zM7.16 7.37c0-1.111 1.526-1.838 1.526-1.838s-.882.473-.882 1.792c0 1.318.458 1.89.458 1.89S7.16 8.48 7.16 7.368zm5.149-.061c0-1.111-1.525-1.777-1.525-1.777s.882.473.882 1.792c0 1.318-.458 1.89-.458 1.89s1.1-.794 1.1-1.905zm-4.107.303c-.058-1.11.865-2.104.865-2.104s-.336.457-.267 1.774c.024.452.202 1.124.426 1.521V5.578h.938V8.83c.225-.37.398-1.002.422-1.46.069-1.318-.251-1.863-.251-1.863s.923.994.865 2.104c-.035.66-.543 1.36-.949 1.817.197.044.461.098.825.17.007.04-.074.038-.235.034a5.149 5.149 0 0 0-.813.035c-.165.17-.28.27-.28.27L9.7 9.88a1.55 1.55 0 0 0-.046.059s-.116-.101-.281-.27a5.148 5.148 0 0 0-.814-.036c-.16.004-.241.006-.234-.035.364-.071.628-.125.825-.169-.406-.457-.914-1.156-.949-1.817z"
          fill="#E31D1C"
        />
      </g>
    </g>
  </svg>
);

export default FlagIr;
